<template>

    <v-form
        ref='form'
        v-model='valid'
        lazy-validation
        @submit.prevent='assign(model)'>
        <v-container class='ChangeManager' id='ChangeManager'>
            <v-row>
                <v-col cols='12'>
                    <h3 class='d-block flex-grow-1 mb-4 mt-3'>
                        <span>شما هم اکنون مدیر </span>
                        <span> {{translate.apartment.type[apartment.type]}} </span>
                        <br>
                        <span> {{ apartment.title }} </span>
                        <span>هستید.</span>
                    </h3>
                    <v-alert
                        text
                        border='left'
                        prominent
                        color='info' class='mx-auto mb-5'>
                        <v-card-text class='px-0 py-0'>
                            <div class='mb-3'>
                              <v-icon color='info' class='ml-1'>mdi-alert-circle-outline</v-icon>
                              <span class="font-weight-bold text--primary">نکات مهم :</span>
                                <span class='text--primary'>در صورتی که مدیر </span>
                                <span class='text--primary'> {{translate.apartment.type[apartment.type]}} </span>
                                <span class='text--primary'>هستید دکمه مدیر </span>
                                <span class='text--primary'> {{translate.apartment.type[apartment.type]}} </span>
                                <span class='text--primary'>هستم راانتخاب کنید، در غیر اینصورت اطلاعات مدیر </span>
                                <span class='text--primary'> {{translate.apartment.type[apartment.type]}} </span>
                                <span class='text--primary'>را در فرم پایین تکمیل نمایید و دکمه تغییر مدیر را انتخاب کنید.</span>

                                <br>
                                <span class='text--primary'>توجه داشته باشید که با تغییر مدیر دسترسی های مدیریتی </span>
                                <span class='text--primary'> {{translate.apartment.type[apartment.type]}} </span>
                                <span class='text--primary'> از شما گرفته خواهد شد و به مدیر جدید اعطا میشود.</span>
                            </div>
                            <div v-if='redirectTo ==="initialisation"'>
                                <v-btn
                                    class='mx-0'
                                    name='cancel'
                                    dark
                                    color='primary'
                                    @click='redirectHandler'
                                >
                                    <div>
                                        <span>مدیر </span>
                                        <span> {{translate.apartment.type[apartment.type]}} </span>
                                        <span>هستم</span>
                                    </div>
                                </v-btn>
                            </div>
                        </v-card-text>
                    </v-alert>
                </v-col>
                <v-row no-gutters justify-sm='center'>
                    <v-col cols='12' sm='8' md='6' lg='4'>
                        <v-col cols='12'>
                            <v-text-field
                                v-model='model.name'
                                :rules='rules.name'
                                placeholder='نام و نام خانوادگی'
                                required
                            >
                                <template #label>
                                    <span class='red--text'><strong>* </strong></span>نام و نام خانوادگی
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols='12'>
                            <v-text-field
                                :rules='rules.phone'
                                v-model='model.phone'
                                placeholder='شماره تلفن همراه'
                                type='number'
                                persistent-hint
                                :counter='11'
                                required
                            >
                                <template #label>
                                    <span class='red--text'><strong>* </strong></span>شماره تلفن همراه
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols='12'>
                            <v-btn
                                v-if='redirectTo !== "initialisation"'
                                class='mb-3 mx-0'
                                name='cancel'
                                block
                                :dark='redirectTo === "initialisation"'
                                :color='redirectTo === "initialisation" ? "primary":null'
                                :outlined='redirectTo !=="initialisation"'
                                @click='redirectHandler'
                            >
                                مدیر مجموعه هستم
                            </v-btn>
                            <v-btn
                                class='mb-3 mx-0'
                                :disabled='!valid'
                                block
                                :loading='loadingChangeManager'
                                name='accept'
                                type='submit'
                                :color='redirectTo !== "initialisation" ? "error":null'
                                :outlined='redirectTo ==="initialisation"'
                                @click='validate'
                            >
                                تغییر مدیر
                            </v-btn>
                        </v-col>
                    </v-col>
                </v-row>
            </v-row>
        </v-container>
        <v-dialog
            v-model='dialog'
            max-width='290'
        >
            <v-card>
                <v-card-title class='body-1'>تایید تغییر مدیر مجموعه</v-card-title>
                <v-card-text>
                    <span>مدیر محترم در صورت تایید نهایی شما مدیریت به آقا/ خانم </span>
                    <span class='font-weight-bold'> {{ model.name }} </span>
                    <span> با شماره </span>
                    <span class='font-weight-bold'> {{ model.phone }} </span>
                    <span>واگذار میگردد.</span>
                    <br />
                    <span>و دسترسی فعلی شما بعنوان مدیریت مجموعه </span>
                    <span class='font-weight-bold'> {{ apartment.title }} </span>
                    <span></span>
                    <span> مسدود خواهد شد.</span>
                </v-card-text>

                <v-card-actions class='d-flex justify-space-between'>
                    <v-btn
                        :loading='loadingChangeManager'
                        outlined
                        disabled
                        name='accept'
                        color='green darken-1'
                        @click='submitAssignManager'
                    >
                        تایید میکنم
                    </v-btn>
                    <v-btn
                        outlined
                        name='cancel'
                        @click='dialog= false'
                    >
                        لغو درخواست
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<style>
    .dir-ltr {
        direction: ltr;
    }
</style>

<script>
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';


    export default {
        name: 'assign',
        props: {
            message: String
        },
        data: () => ({
            loadingChangeManager: false,
            apartment: {},
            apartment_id: '',
            role: '',
            redirectTo: null,
            valid: true,
            model: {
                name: '',
                phone: '',
                apartment_id: ''
            },
            rules: {
                name: [
                    v => !!v || 'نام و نام خانوادگی اجباری میباشد',
                    v => !!v && v.length > 4 ? true : 'نام و نام خانوادگی باید بیشتر از ۴ حرف باشد'
                ],
                phone: [
                    v => !!v || 'شماره تلفن همراه اجباری میباشد',
                    v => /^09\d{2}\d{7}$/.test(v) ? true : 'شماره تلفن همراه با 0 شروع شود و 11 حرف باشد'
                ]
            },
            items: [],
            search: null,
            loading: false,
            dialog: false
        }),

        methods: {
            validateState(name) {
                const { $dirty, $error } = this.$v.model[name];
                return $dirty ? !$error : null;
            },
            handleGetPhoneNumber(val) {
                if (val.length <= 11) {
                    this.model.phone = val.trim();
                }
            },
            goBack() {
                this.$store.commit('goBack');
                this.$router.replace(this.$store.state.history.page);
            },
            redirectHandler() {
                switch (this.redirectTo) {
                    case 'Home':
                        return this.$router.push({ name: 'Home' });
                    case 'goBack':
                        return this.goBack();
                    default:
                        return this.$router.push({
                            name: 'CreateCashDesk',
                            params: { apartment_id: this.apartment_id }
                        });
                }
            },
            validate() {
                this.$refs.form.validate();
            },
            checkPermission(apartment_id) {
                this.role = this.roles[apartment_id];
                if (this.role !== 'MANAGER') {
                    //todo Force: redirect to setting
                }
            },
            async submitAssignManager() {
                this.loadingChangeManager = true;
                await axios
                    .post(
                        `/api/apartments/${this.apartment_id}/manager/change`,
                        this.model
                    )
                    .then(async () => {
                        this.dialog = false;
                        let role = {};
                        role[this.apartment_id] = 'USER';
                        this.setRole(role);
                        const message = 'درخواست شما با موفقیت ثبت شد';
                        await this.$snackbar.showMessage({ content: message, color: 'success' });
                        this.loadingChangeManager = false;
                        if (this.redirectTo === 'goBack') {
                            await this.$router.push({
                                name: 'Home'
                            });
                        } else {
                            await this.$router.push({
                                name: 'AddUnitToApartment'
                            });
                        }
                    })
                    .catch(() => {
                        this.dialog = false;
                        this.loadingChangeManager = false;
                    });

            },
            assign() {
                this.dialog = true;
            },

            async fetchApartmentData() {
                await axios
                    .get('/api/apartments/' + this.apartment_id)
                    .then(res => {
                        this.apartment = res.data.apartment;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            ...mapActions(['setRole'])

        },
        computed: {
            ...mapState(['roles','translate'])
        },
        async created() {
            this.redirectTo = sessionStorage.getItem('redirectTo');
            console.log(this.redirectTo);
            this.apartment_id = this.$route.params.apartment_id;
            this.model.apartment_id = this.$route.params.apartment_id;
//            this.unit_id = this.$route.params.unit_id;
//            this.user_id = this.$route.params.user_id;
            this.checkPermission(this.apartment_id);
            await this.fetchApartmentData();
        }
    };
</script>